<template>
  <div class="add-plan-body">
    <!-- 如果要加回显就把addTarget换成props.target,需让后端
      把接口system/selectUserList多传typeId和roleId -->
    <EditCom
      :target="addTarget"
      :inputList="addInputList"
      :buttonList="addButtonList"
      :rules="addRules"
      :title="props.title"
      @closeFun="closeAdd"
      ref="edit_com"
    />
  </div>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue';
import EditCom from '@/components/EditCom/index.vue'
import { getAccountTypeSelection, getRoleSelection, addUser, modifyUserInfo } from '@/api/System/UserManager/index'
import { message,dayjs } from '@/utils/js/initVariable'

import {
  queryFootPrintMapList,
} from '@/api/MapManage';

const props = defineProps({
  target: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: () => ({})
  }
})

const closeAdd = ()=>{
  emit('close')
}
const subPort = computed(()=>{
  return props.target.userId?modifyUserInfo:addUser;
})
const submitFn = (form, target, button, loadFn)=>{
  const data = {
    userId: target.userId,
    userName: target.userName,
    tel: target.tel,
    pwd: target.pwd,
    typeId: target.typeId,
    roleId: target.roleId,
    mapIds: target.mapIds || [],
    effectiveTime: target.effectiveTime?dayjs(target.effectiveTime).format('YYYY-MM-DD HH:mm:ss'):undefined,
    tileEffectiveTime: target.tileEffectiveTime?dayjs(target.tileEffectiveTime).format('YYYY-MM-DD HH:mm:ss'):undefined,
  }
  subPort.value(data).then((res) => {
    if (res.data.code === 1004) {
      message('编辑成功', 1)
      closeAdd()
      emit('refresh')
    }
    loadFn && loadFn();
  }).catch((err) => {
    loadFn && loadFn();
    console.log(err)
  })
}
const addSubmit = (form, target, button, loadFn) => {
  form.value.validate((valid) => {
    if (valid) {
      submitFn(form, target, button, loadFn);
    } else {
      loadFn && loadFn();
    }
  })
}
// 组件EditCom
const addTarget = reactive({
  ...props.target,
  typeId: props.target['accountTypePid']
})
const addInputList = ref([]),
      addButtonList = ref([
        { name: '取消', fun: closeAdd, type: 'danger', },
        { name: '确定', fun: addSubmit, type: 'primary', },
      ]),
      addRules = reactive({})
const form = ref({
  userName: '',
  pwd: '',
  tel: '',
  typeId: '',
  roleId: '',
  effectiveTime: ''
})

const formRef = ref(null)

const eventTypes = ref([])

const emit = defineEmits(['close', 'confirm', 'refresh'])

const editFlag = ref(false)

const close = () => {
  emit('close')
}

const fetchType = () => {
  getAccountTypeSelection({}).then(async res=>{
    if(res.data.code == 1004) {
      // props.target.typeList = res.data.data
      addTarget.typeList = res.data.data
    }
  }).catch(err=> {
    console.log(err)
  })
}
const fetchRole = () => {
  getRoleSelection({}).then(res=>{
    if(res.data.code == 1004) {
      // props.target.roleList = res.data.data
      addTarget.roleList = res.data.data
    }
  })
}

const queryFootPrintMapListFn = ()=>{
  queryFootPrintMapList({}).then(res=>{
    if(res.data.code == 1004){
      addTarget.tileList = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
}

const getinputList = () => {
    addInputList.value = [
      { name: '用户名', prop: 'userName', type: 'input'},
      props.target.userId?undefined:{ name: '密码', prop: 'pwd', type: 'input' },
      { name: '联系电话', prop: 'tel', type: 'input' },
      {
        name: '账户类型', prop: 'typeId', type: 'select', select: {
          list: 'typeList',
          key: 'typeId',
          label: 'roleName',
          value: 'typeId'
        }
      },
      {
        name: '用户角色', prop: 'roleId', type: 'select', select: {
          list: 'roleList',
          key: 'roleId',
          label: 'roleName',
          value: 'roleId'
        }
      },
      { name: '有效时间', prop: 'effectiveTime', type: 'datetime', date: {} },
      { name: '底图', prop: 'mapIds', type: 'select',
        select: {
          list: 'tileList',
          label: 'layerName',
          value: 'id',
          multiple: true,
        },
      },
      { name: '底图有效时间', prop: 'tileEffectiveTime', type: 'datetime', date: {} },
    ].filter(e=>e)
    addRules.userName = [
      { required: true, message: '请输入用户名', trigger: 'blur' },
    ]
    addRules.pwd = [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ]
    addRules.tel = [
      { required: true, message: '请输入联系电话', trigger: 'blur' }
    ]
    addRules.typeId = [
      { required: true, message: '请选择账户类型', trigger: 'change' }
    ]
    addRules.roleId = [
      { required: true, message: '请选择用户角色', trigger: 'change' }
    ]
    addRules.effectiveTime = [
      { required: true, message: '请选择账号有效时间', trigger: 'change' }
    ]
}

onMounted(() => {
  fetchType()
  fetchRole()
  getinputList()
  queryFootPrintMapListFn();
})
</script>

<style lang="less" scoped>
.add-plan-body {
  z-index: 2;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.additional-info {
  margin-top: 16px;
}
</style>